export default function BackSpot() {
  return (
    <svg
      id="Group_3_Copy_24"
      data-name="Group 3 Copy 24"
      xmlns="http://www.w3.org/2000/svg"
      width="230"
      height="130"
      viewBox="0 0 230 130"
    >
      <path id="Clip_2" data-name="Clip 2" d="M0,0H230V130H0Z" fill="none" />
      <path
        id="Fill_1"
        data-name="Fill 1"
        d="M207.734,24.367q-23.951,6.092-47.7,12.914,3.7-2.153,7.405-4.306c17.183-10,5.842-37.786-13.607-32.254-18.3,5.2-36.478,10.776-54.594,16.57-4.212-2.726-9.421-3.973-14.354-2.382A367.8,367.8,0,0,0,8.429,49.448C-.5,54.8-1.592,64.1,1.71,71.488c2.416,7.717,9.236,13.5,18.734,10.732a17.946,17.946,0,0,0,4.574-1.638q8.75-3.322,17.536-6.556c-3.688,2.106-7.367,4.229-11.084,6.294-9.421,5.238-10.363,14.846-6.637,22.328,2.652,7.97,10.048,13.776,20.247,9.926.127-.05.256-.1.383-.144a18.379,18.379,0,0,0,2.066-.762c3.373-1.271,6.755-2.5,10.134-3.75,2.634,8.905,11.072,16.355,21.368,12.608,18.993-6.914,37.735-14.426,56.316-22.358q14.578,13.451,29.147,26.9c6.3,5.811,13.927,6.15,21.4,2.759,9.769-4.429,18.013-10.047,26.383-16.7a14,14,0,0,0,5.348-12.82c3.859-5.938,3.605-13.67.492-19.564a18.4,18.4,0,0,0,.253-4.856,15.763,15.763,0,0,0,5.151-18.664c14.569-10.655,2.519-35.513-15.785-30.857"
        fill="#f0ff93"
      />
    </svg>
  )
}
